export enum ELocale {
  checkin = 'guest-area-locale',
  payments = 'guest-area-locale',
  DEFAULT = 'en_GB',
  inbox = 'inbox-locale',
  GUEST_AREA = 'guest-area-locale',
  checkout = 'guest-area-locale'
}
